import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Banner, Card } from 'src/components/ui'
import { useTitle } from 'src/utility'
import { useSite } from 'src/contexts/site'
import * as events from 'src/utility/events'
import {
  AnomalyCommentsCard,
  RecentAnomaliesCard,
  AssetStatusCard,
  MetropolisDashboardCard,
} from './cards'

export function DashboardPage(): JSX.Element {
  useTitle('Dashboard')

  const { id, name, isWorkshop, isDataExplorerWorkshop, rootLink } = useSite()

  useEffect(() => {
    events.dashboardPageViewed({
      fid: id,
      siteName: name,
    })
  }, [id, name])

  if (isWorkshop) {
    return (
      <div className="mx-4 mb-4">
        <Card>
          <MetropolisDashboardCard />
        </Card>
      </div>
    )
  }

  return (
    <div className="mx-4 mb-4 grid grid-cols-6 gap-4">
      {isDataExplorerWorkshop && (
        <Banner className="col-span-6">
          Click the link to open the walkthrough guide:
          <a
            href="https://intelecy.notion.site/Intelecy-No-Code-AI-Walkthrough-Workshop-2a52e504235a420b8900a3d9df18fcc3"
            target="_blank"
            rel="noreferrer"
          >
            Intelecy Data Explorer Workshop Walkthrough
          </a>
        </Banner>
      )}
      <Card padding="24px" className="col-span-6 @container">
        <RecentAnomaliesCard />
      </Card>

      <Card padding="24px" className="col-span-6 md:col-span-4">
        <AnomalyCommentsCard />
      </Card>
      <Card
        as={Link}
        to={`${rootLink}/assets`}
        className="col-span-6 self-start md:col-span-2"
        $hovercolor
      >
        <AssetStatusCard />
      </Card>
    </div>
  )
}
